import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import '../../../src/App.css';
import './HeroSection.css';
import dollAndRocket from '../../../src/assets/doll_and_rocket.png';
import gridBackground from '../../../src/assets/gridBackground_grey_3_opacity.png';
import lamp from '../../../src/assets/lamp.png';
import clouds from '../../../src/assets/clouds.png';

const HeroSection = () => {
  return (
    <section id="hero-section" className="hero-section" style={{ backgroundImage: `url(${gridBackground})` }}>
      {/* Nubes */}
      <div className='col-lg-12'>
        <img src={clouds} alt="Nubes" className="clouds"/>
      </div>

      <Container className="text-white">
        <Row className="align-items-center hero-row">
          {/* Texto Hero */}
          <Col xs={12} md={6} className="text-start hero-copy">
            <Row>
              <Col className="col-lg-11 col-md-12 font-montserrat text-ia display-4">
                <p className="lh-base">
                  Crecimiento <br />
                  Impulsado por <br/>
                  Inteligencia Artificial
                </p>
              </Col>
              <Col xs="auto" className="hero-lamp">
                <img src={lamp} alt="Bombillo" className="lamp"/>
              </Col>              
            </Row>
            <Row>
              <Col className='col-lg-12'>
                <p className="fs-6 font-inter text-center custom-bg">
                  Haz que los datos trabajen para ti con nuestras soluciones tecnológicas
                </p>
              </Col>
            </Row>
          </Col>

          {/* Imagen del muñeco */}
          <Col xs={12} md={6} className="hero-visual">
            <img src={dollAndRocket} alt="Muñeco y cohete" className="doll-rocket" />
          </Col>
        </Row>        
      </Container>      
    </section>
  );
};

export default HeroSection;
